import type { GenericError, RequestStatus } from '@skynet/data-ws-core';
import type { JsonLiquidityExchange } from '@skynet/data-liquidity-types';

export enum ExchangeLiquidityCommands {
  // Wire command name as sent by the backend; kept verbatim as the contract.
  LoanExchanges = 'LoanExchanges',
}

export interface JsonExchangeLiquiditySuccess {
  id: number;
  command: ExchangeLiquidityCommands.LoanExchanges;
  exchanges: JsonLiquidityExchange[];
  pairs: string[];
  supportedExchanges: number[];
}

export type ExchangeLiquidityCache = Record<string, JsonLiquidityExchange[]>;

export interface ExchangeLiquidityState {
  requestStatus: RequestStatus;
  error: null | GenericError;

  list: JsonLiquidityExchange[];
  supportedPairs: string[];
  supportedExchanges: number[];
  hideNotSupportExchange: boolean;
  listCache: ExchangeLiquidityCache;
}
